module.exports = __webpack_public_path__ + "img/Truppführer_UL.63fef4ed.svg";